export default __webpack_public_path__ + "media/images/seals/secure-purchase-ca659ff5da0c5eec90270c281b139d7f.png";